import { defineComponent as _defineComponent } from 'vue'
import { onMounted, watch,ref } from 'vue'

type Props = {
    label?: string,
    disabled?: boolean,
    placeholderText?: string,
    noBorder?: boolean,
    modelValue?: string
    passedRows?: string,
    passedCols?: string,
    readOnly?: boolean
}
type Emits = {
    (e: 'update:modelValue', value: string): void  
}

export default /*#__PURE__*/_defineComponent({
  __name: 'text-area',
  props: {
    label: null,
    disabled: { type: Boolean },
    placeholderText: null,
    noBorder: { type: Boolean, default: false },
    modelValue: null,
    passedRows: null,
    passedCols: null,
    readOnly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:modelValue', value: string): void  
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as { label?: string, disabled?: boolean, placeholderText?: string, noBorder: boolean, modelValue?: string, passedRows?: string, passedCols?: string, readOnly?: boolean }

const rows = ref("8")
const cols = ref("38")

onMounted(()=>{
    if(props.passedRows){
        rows.value = props.passedRows
    }
    if(props.passedCols){
        cols.value = props.passedCols
    }
})





const __returned__ = { rows, cols, props, emit, onMounted, watch, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})